module.exports = __webpack_public_path__ + "static/media/Seperator.f3d97b7a.svg";